/**
 * @generated SignedSource<<e90aca21ee305735c6034bcb54d7c1a5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type actionButtonsTracking_item$data = {
  readonly browseUrl: string | null;
  readonly categoryCode: string | null;
  readonly contemporaryTrackingString: string;
  readonly isAuctionEnabled: boolean | null;
  readonly lastTransaction?: {
    readonly secondChanceOffer: {
      readonly amountPerItem: {
        readonly convertedAmounts: {
          readonly USD: number | null;
        } | null;
      } | null;
    } | null;
  } | null;
  readonly pricing: {
    readonly totalAmount: {
      readonly convertedAmounts: {
        readonly USD: number | null;
      } | null;
    } | null;
  } | null;
  readonly relevantAuctionLot?: {
    readonly buyItNowPrice: {
      readonly convertedAmounts: {
        readonly USD: number | null;
      } | null;
    } | null;
  } | null;
  readonly relevantAuctionSolution?: {
    readonly bids: {
      readonly totalResults: number | null;
    } | null;
    readonly highestBidAmount: {
      readonly convertedAmounts: {
        readonly USD: number | null;
      } | null;
    } | null;
  } | null;
  readonly seller: {
    readonly serviceId: string | null;
  } | null;
  readonly serviceId: string | null;
  readonly title: string | null;
  readonly " $fragmentType": "actionButtonsTracking_item";
};
export type actionButtonsTracking_item$key = {
  readonly " $data"?: actionButtonsTracking_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"actionButtonsTracking_item">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "actionButtonsTracking_item"
};

(node as any).hash = "4da6cdd9d8e07a2b163b2e4807d3460d";

export default node;
